import { useEffect, useRef, useState } from "react";
import { API_STATUS } from "../../constants";
import { GetUserMsg } from "../../apis/message/get_user_msg";
import GetTime from "../../utils/gettime";
import { MessageNoteApi } from "../../apis/notification/msg_note_api";
import { UpdateMsgUnread } from "../../apis/message/update_msg_unread";
import { SendMsgApi } from "../../apis/message/send_msg_api";

export default function MessageBox({ udata, onOpenSidebar }) {
    const scrollRef = useRef(null);
    const [loginId, setLoginId] = useState("");
    const [msgData, setMsgData] = useState([]);
    const [msgApi, setMsgApi] = useState(API_STATUS);
    const [unreadApi, setUnreadApi] = useState(API_STATUS);
    const [MsgTxt, setMsgTxt] = useState('');
    const [sconnect, setSconnect] = useState(true);
    const [mid, setMid] = useState('0');

    useEffect(() => {
        setMsgData([]);
        const userCode = sessionStorage.getItem('USER_CODE');
        setLoginId(userCode);
        GetUserMsg(udata['uid'], '0', setMsgApi);
    }, [udata]);

    useEffect(() => {
        scrollRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [msgData]);

    useEffect(() => {
        if (!msgApi.isError && !msgApi.isLoader && msgApi.data != null) {
            if (msgApi.data.status === 1) {
                let res = msgApi.data.data;
                let mlen = msgApi.data.data.length;
                let lindex = mlen - 1;
                let lastId = res[lindex].mid;
                setMid(lastId.toString());
                setMsgData(prevData => [...prevData, ...msgApi.data.data]);
            }
            UpdateMsgUnread(udata['uid'], setUnreadApi);
        }
    }, [msgApi, udata]);

    const sendMsg = () => {
        if (MsgTxt !== "") {
            let body = { 'mfrom': loginId, 'mto': udata['uid'], 'msg': MsgTxt, 'mid': mid };
            SendMsgApi(body, setMsgApi);
            MessageNoteApi(body);
        }
        setMsgTxt('');
    };

    useEffect(() => {
        const interval = setInterval(() => {
            GetUserMsg(udata['uid'], mid, setMsgApi);
        }, 3000);
        return () => clearInterval(interval);
    }, [mid, udata]);

    return (
        <div className="flex-1">

            {/* Header bar */}
            <div className="flex items-center justify-between gap-2 px-6 py-3.5 z-10 border-b dark:border-slate-700">

                <div className="flex items-center sm:gap-4 gap-2">
                    
                    {/* Back Button for mobile view */}
                    <button 
                        type="button" 
                        className="md:hidden text-gray-700 dark:text-white p-2 -ml-4"
                        onClick={onOpenSidebar}
                    >
                        <i className="fa fa-chevron-left text-xl" aria-hidden="true"></i>
                    </button>

                    <div className="relative cursor-pointer max-md:hidden">
                        <img src={udata.user_pic} alt="" className="w-8 h-8 rounded-full shadow" />
                        <div className="w-2 h-2 bg-teal-500 rounded-full absolute right-0 bottom-0 m-px"></div>
                    </div>
                    <div className="cursor-pointer">
                        <div className="text-base font-bold">{udata.first_name + ' ' + udata.last_name}</div>
                        <div className="text-xs text-green-500 font-semibold">{udata.username}</div>
                    </div>

                </div>

                <div className="flex items-center gap-2"></div>

            </div>

            {/* Message bubble list */}
            <div className="w-full p-5 py-10 overflow-y-auto md:h-[calc(100vh-137px)] h-[calc(100vh-250px)]">
                {msgData !== null && msgData.length > 0 && (
                    <div className="text-sm font-medium space-y-6">
                        {msgData.map((item, i) => (
                            <div key={i}>
                                {item.mfrom !== loginId && (
                                    <div className="flex gap-3">
                                        <div className="px-4 py-2 rounded-[20px] max-w-sm bg-secondery">
                                            {item.msg}
                                            <div className="text-xs text-gray-500 text-right">
                                                {item.date === "now" ? "now" : GetTime(item.date)}
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {item.mfrom === loginId && (
                                    <div className="flex gap-2 flex-row-reverse items-end">
                                        <div className="px-4 py-2 rounded-[20px] max-w-sm bg-blue-500 text-white shadow">
                                            {item.msg}
                                            <div className="text-xs text-gray-200 text-right">
                                                {item.date === "now" ? "now" : GetTime(item.date)}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        ))}
                        <div ref={scrollRef}></div>
                    </div>
                )}
            </div>

            {/* Input Footer */}
            <div className="flex items-center md:gap-4 gap-2 md:p-3 p-2 overflow-hidden">
                <div className="relative flex-1">
                    <textarea
                        value={MsgTxt}
                        onChange={(e) => setMsgTxt(e.target.value)}
                        placeholder="Write your message"
                        rows="1"
                        className="w-full resize-none bg-secondery rounded-full px-4 p-2 pr-12"
                    ></textarea>
                    {sconnect && (
                        <button
                            onClick={sendMsg}
                            type="button"
                            className="bg-blue-500 text-white shrink-0 p-1.5 px-3 absolute right-1 top-1 rounded-full"
                        >
                            <i className="fa fa-paper-plane" aria-hidden="true"></i>
                        </button>
                    )}
                </div>
            </div>

        </div>
    );
}